<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" size="medium"
          label-suffix="：" :rules="rules" label-width="82px">
          <el-form-item label="客户">
            <el-select v-model="searchForm.TC_ID" filterable placeholder="请选择客户" clearable @change="onTCChange"
              style="width: 250px;">
              <el-option v-for="item in tcList" :key="item.value" :label="item.AB_NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目点">
            <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable @change="queryDkList"
              style="width: 250px;">
              <el-option v-for="item in projectList" :key="item.value" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="档口">
            <el-select filterable v-model="searchForm.DK_ID" placeholder="请选择档口" clearable style="width: 250px;">
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="供应商">
            <el-select v-model="searchForm.SUPPLIER_ID" filterable placeholder="请选择供应商" clearable style="width: 250px;">
              <el-option v-for="item in supplierList" :key="item.value" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单号" prop="ORDER_ID">
            <el-input v-model="searchForm.ORDER_ID" style="width: 250px;" placeholder="请输入订单号" clearable />
          </el-form-item>
          <el-form-item label="订单日期">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" :clearable="false" style="width: 250px;" />
          </el-form-item>
          <el-form-item label="产品编码" prop="PRODUCT_CODE">
            <el-input v-model="searchForm.PRODUCT_CODE" placeholder="请输入产品编码" style="width: 250px;" clearable />
          </el-form-item>
          <el-form-item label="产品名称" prop="PRODUCT_NAME">
            <el-input v-model="searchForm.PRODUCT_NAME" placeholder="请输入产品名称" style="width: 250px;" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" id="search" @click="handleSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column prop="ORDER_ID" label="订单ID" width="80" />
          <el-table-column prop="SUPPLIER_NAME" label="供货商" min-width="200" />
          <el-table-column prop="TC_NAME" label="客户" min-width="200" />
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="200" />
          <el-table-column prop="DK_NAME" label="档口" min-width="200" />
          <el-table-column prop="SEND_DAY" label="订单日期" width="95" />
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="170" />
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="200" />
          <el-table-column prop="TYPE_UNIT" label="单位" width="65" />
          <el-table-column prop="REAL_PRICE" label="采购价" width="65" />
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税采购价" min-width="120" />
          <el-table-column prop="TAX_RATE" label="税率" width="55" />
          <el-table-column prop="PRODUCT_COUNT" label="订单数量" width="80" />
          <el-table-column prop="NEED_COUNT" label="送货数量" width="80" />
          <el-table-column label="操作" fixed="right" width="60">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="modifyPrice(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" />
      </el-col>
    </el-row>

    <el-dialog title="修改" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" size="small" :rules="rules" label-width="110px">
        <el-form-item label="产品名称：">
          <span>{{ this.editForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：">
          <span>{{ this.editForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="采购价：" prop="REAL_PRICE">
          <el-input v-model="editForm.REAL_PRICE" @input="editRealPriceInput" />
        </el-form-item>
        <el-form-item label="不含税采购价：" prop="BEFORE_TAX_PRICE">
          <el-input v-model="editForm.BEFORE_TAX_PRICE" readonly />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitEdit('editForm')" :loading="editLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryCustomerFun, haveSupplierFun,
} from '@/assets/api/DSOrder';
import {
  getHaveSupplyRelationshipProjectList,
} from '@/assets/api/sellOrder';
import { modifyOrderFun } from '@/assets/api/shopOrderManage';
import date from '@/assets/common/date';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';


export default {
  data () {
    return {
      PAGE_ID: '', // 页面ID 一旦规定不要轻易改动
      fun_dic: {}, // 功能ID 一旦规定不要轻易改动
      rules: {
        COMPANY: [
          { required: true, message: '请选择客户', trigger: 'blur' },
        ],
        REAL_PRICE: [{ required: true, message: '请输入采购价', trigger: 'input' }, {
          validator: (r, v, cb) => {
            if (validation.价格正数验证(v)) cb();
            else cb(Error('请输入正数的采购价'));
          },
          trigger: 'blur',
        }],
        ORDER_ID: [{
          validator: (r, v, cb) => {
            if (v && !validation.订单ID验证(v)) cb(Error('请输入正确的订单号'));
            else cb();
          },
          trigger: 'blur',
        }],
        PRODUCT_CODE: [{
          validator: (r, v, cb) => {
            if (validation.产品编码验证(v)) cb();
            else cb(Error('请输入正确的产品编码'));
          },
          trigger: 'blur',
        }],
        PRODUCT_NAME: [{
          max: 300,
          message: '产品名称不能超过300个字',
          trigger: 'blur',
        }],
      },
      tcList: [],
      projectList: [],
      dkList: [],
      supplierList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '本月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              // 设置为本月第一天
              start.setDate(1);
              // 设置时间为 00:00:00
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {
        TC_ID: '',
        PROJECT_ID: '',
        DK_ID: '',
        SUPPLIER_ID: '',
        ORDER_ID: '',
        PRODUCT_CODE: '',
        PRODUCT_NAME: '',
        DAY_INTERVAL: [date(new Date().getTime() - 3600 * 1000 * 24 * 30, '%F'), date(new Date(), '%F')],
      },
      tableData: [],
      editFormVisible: false,
      editForm: {},
      editLoading: false,
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    DS_UNPRICE_ORDER_DETAIL_CONDITION () {
      return this.$store.state.DS_UNPRICE_ORDER_DETAIL_CONDITION;
    },
  },
  created () {
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.DS_UNPRICE_ORDER_DETAIL_CONDITION.CONDITION) {
      this.searchForm = this.DS_UNPRICE_ORDER_DETAIL_CONDITION.CONDITION;
      this.currentPage = this.DS_UNPRICE_ORDER_DETAIL_CONDITION.CURRENT_PAGE;
    }
    this.queryCustomer();
    this.queryProjectList();
    this.querySupplier();
    if (this.searchForm.PROJECT_ID) {
      this.queryDkList();
    }
  },
  mounted () {
    this.queryData();
  },
  methods: {
    queryCustomer () {
      const params = {};
      queryCustomerFun(params).then((result) => {
        if (result.length !== 0) {
          this.tcList = result[0].company;
        } else {
          this.tcList = [];
        }
      }).catch((error) => this.$message.show({ text: error, type: 'error' }));
    },
    queryProjectList () {
      const params = {};
      if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        this.projectList = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySupplier () {
      const params = {};
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_NAME = this.searchForm.SUPPLIER_ID;
      }
      haveSupplierFun().then((result) => {
        this.supplierList = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 改变项目点 拉取档口
    queryDkList () {
      if (!this.searchForm.PROJECT_ID) {
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECTS_ID = [this.searchForm.PROJECT_ID];
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = this.$util.listRemoveDuplicates(result);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    handleSearch () {
      this.currentPage = 1;
      this.queryData();
    },
    // -----------------------获取新订单列表
    queryData () {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10179',
            OTYPE: 90,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PAGE_SIZE: this.pageSize,
            PAGE_INDEX: this.currentPage - 1,
          };
          for (const key of ['TC_ID', 'PROJECT_ID', 'DK_ID', 'SUPPLIER_ID', 'ORDER_ID']) if (this.searchForm[key]) params[`${key}_LIST`] = [this.searchForm[key]];

          if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL.length == 2) {
            [params.START_DATE, params.END_DATE] = this.searchForm.DAY_INTERVAL;
          }
          http.post(params).then((res) => {
            if (res.length && res[0].LIST && res[0].TOTAL_COUNT) {
              this.tableData = res[0].LIST;
              this.totalCount = res[0].TOTAL_COUNT;
              this.$store.dispatch('SET_DS_UNPRICE_ORDER_DETAIL_CONDITION', {
                CONDITION: this.searchForm,
                CURRENT_PAGE: this.currentPage,
              });
            } else {
              this.tableData = [];
              this.totalCount = 0;
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    onTCChange () {
      this.searchForm.PROJECT_ID = '';
      this.searchForm.DK_ID = '';
      this.queryProjectList();
    },
    modifyPrice (row) {
      // 关账限制
      if (this.$util.isOrderClosed(row.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.editForm = { ...row };
      this.editFormVisible = true;
    },
    editRealPriceInput (val) {
      this.editForm.NEW_BEFORE_TAX_PRICE = Number((val / (1 + this.editForm.TAX_RATE / 100)).toFixed(10));
      this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
    },
    submitEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const updateParams = {
            ORDER_DETAIL_ID: Number(this.editForm.PURCHASE_DETAIL_ID),
            ORDER_ID: this.editForm.ORDER_ID,
            PRODUCT_COUNT: Number(this.editForm.REAL_COUNT),
            PRICE: this.editForm.REAL_PRICE,
            BEFORE_TAX_PRICE: this.editForm.NEW_BEFORE_TAX_PRICE || this.editForm.BEFORE_TAX_PRICE,
            TAX_RATE: this.editForm.TAX_RATE,
          };
          this.editLoading = true;
          modifyOrderFun(updateParams).then(() => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editLoading = false;
            this.editFormVisible = false;
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.editLoading = false;
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.el-button--text {
  margin: 0 0 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSUnpriceOrderDetail.vue